import { StyledHint } from './styles';
interface IHintProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}
export const Hint = (props: IHintProps) => {
  return <StyledHint {...props}>{props.children}</StyledHint>;
};
